import setupConditionsUpdate from "../objects/set_up_conditions_update_function";

export const createPendingJobObj = (currentJob, newJob, totalNbrYearsCollege, adjustedNbrYearsCollege,
        conditionList, loanTable ) => {
    let changeHealthIns = false;
    if (currentJob.healthInsInd !== newJob.healthInsInd){
        changeHealthIns = true;
    }
    let jobInfoObj = {careerID:  newJob.careerID , careerName: newJob.careerName, 
            newMonthlySalary: newJob.jobSalary , healthInsInd: newJob.healthInsInd,
            changeHealthIns: changeHealthIns, jobRank: newJob.jobRank, 
            totalNbrYearsCollege: totalNbrYearsCollege, nbrYearsCollege: adjustedNbrYearsCollege};
    let newGameData={jobInfo: {careerID:  newJob.careerID }};
    let conditionClasses = ["career"];
    let pendingJobConditions = 
            setupConditionsUpdate(newGameData, conditionList, conditionClasses);
    const pendingJobObj = {class: "career", jobStartDate: newJob.jobStartDate, jobInfo: jobInfoObj,
            jobConditions: pendingJobConditions, loanTable: loanTable, pictureInfo: ""}
    return pendingJobObj;
}
export default createPendingJobObj;